const objectMapping = require('./object-mapping');
const languageSelector = require('./language-selector');
const translation = require('./translation');
const dynamicTranslation = require('./dynamic-translation');
const youtubeIframe = require('./youtube-iframe');

module.exports = [objectMapping, languageSelector, translation, dynamicTranslation, youtubeIframe];
